import { Alert, Divider, Skeleton } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import gql from 'graphql-tag';
import { useAuthedQuery } from 'utils/qlAuth';

export const RunwaymlVideoAutomation = (props: { qStory: any; storyId: number }) => {
  const qFrames = useAuthedQuery(
    gql`
      query FrameController_getRunwaymlVideoAutomation($storyId: Int!) {
        FrameController_getRunwaymlVideoAutomation_Robot(storyId: $storyId)
      }
    `,
    {
      variables: { storyId: Number(props.storyId) },
    },
  );

  if (qFrames.error) {
    return <div>error</div>;
  }
  if (qFrames.loading) {
    return <Skeleton active />;
  }

  const jsonStringRobot = qFrames.data?.FrameController_getRunwaymlVideoAutomation_Robot;
  return (
    <>
      <Alert
        message="RunwayML Video Automation"
        description={
          <>
            <code>cd /home/victor/GIT/ai-threshold/packages/cloud-backend</code>
            <br />
            <code>
              ./xrobot.sh /home/victor/Yandex.Disk/ai-threshold-storage/story-{props.storyId}/runwayml-video-robot-{props.storyId}.js
            </code>
          </>
        }
        type="info"
        showIcon
        style={{ marginBottom: '16px' }}
      />
      <TextArea rows={30} value={jsonStringRobot} />
    </>
  );
};
